import { useEffect, useState } from "react";
import ButtonOutlineSmall from "../../components/Button/ButtonOutlineSmall";
import ButtonSolidSmall from "../../components/Button/ButtonSolidSmall";
import ButtonDropdown from "../../components/ButtonDropdown/ButtonDropdown";
import ChipSuggest32 from "../../components/Chip/ChipSuggest32";
import { useSelector } from "react-redux";
import i18next from "i18next";

const ButtonDropdownShape = ({
  id,
  shapeFilter,
  setShapeFilter,
  showButton,
}) => {
  const { dataProductCategory } = useSelector(
    (state) => state.dataProductCategory
  );

  const [tempShape, setShape] = useState([]);

  const closeModal = () => {
    const dropdown = document.getElementById(id + "Dropdown-Container");

    if (dropdown) {
      dropdown.classList.remove("show");
      dropdown.classList.add("hidden");
    }
  };

  useEffect(() => {
    setShape([...shapeFilter]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shapeFilter]);

  return (
    <ButtonDropdown
      isHidden={true}
      title={i18next.t("filter.design")}
      badge={shapeFilter?.length ? shapeFilter?.length : undefined}
      id={id}
      container={
        <div className="material--filter--container">
          <div className="material--filter--container-content">
            {dataProductCategory?.shapeFilter?.map((style, i) => (
              <ChipSuggest32
                key={i}
                title={style?.title}
                onClick={() => {
                  const newMaterial = showButton
                    ? tempShape
                    : shapeFilter;
                  const index = newMaterial?.findIndex(
                    (id) => id === style._id
                  );
                  if (index > -1) {
                    newMaterial.splice(index, 1);
                  } else newMaterial.push(style?._id);
                  if (showButton) setShape([...newMaterial]);
                  else setShapeFilter([...newMaterial]);
                }}
                isSelected={tempShape?.includes(style?._id)}
              />
            ))}
          </div>
          {showButton && (
            <div className="material--filter--container-button">
              <ButtonOutlineSmall
                title={i18next.t("filter.button.close")}
                type={"button"}
                onClick={() => {
                  closeModal();
                  setShapeFilter(undefined);
                }}
              />
              <ButtonSolidSmall
                title={i18next.t("filter.button.apply")}
                type={"button"}
                onClick={() => {
                  closeModal();
                  setShapeFilter(tempShape);
                }}
              />
            </div>
          )}
        </div>
      }
    />
  );
};

export default ButtonDropdownShape;
